<div class="grid lg:grid-cols-12 md:grid-cols-1 py-24 bg-white px-4 sm:px-5 md:px-0">
  <div class="xs:col-span-12 sm:col-span-12 md:col-span-10 md:col-start-2 lg:col-start-4 lg:col-span-6">
    <div class="mx-auto max-w-3xl text-center">
      <p class="text-center text-gray-900 text-4xl font-extrabold font-['Inter'] leading-tight">
        {{ title }}
      </p>
      <p class="mt-5 text-center text-gray-500 text-lg sm:text-xl font-normal font-['Inter'] leading-relaxed">
        {{ description }}
      </p>
      <button
        type="button"
        class="mt-6 inline-flex items-center justify-center rounded-md bg-blue-700 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-200"
        (click)="onSelect()">
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</div>
